import React from 'react'
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import AcoesRemarcacaoCancelamento from './AcoesRemarcacaoCancelamento';


export default class Remarcacao extends React.Component {
  exibirReservas(reserva){
    if(!reserva.sePodeRemarcarOuCancelar){
      return (
          <div className='resumo' style={{backgroundColor: '#5af18f4f'}}>
            <div className="row">
              <div className="col">
                <span className="titulo-mobile">Empresa:&nbsp;</span> {capitalizarTodasPrimeirasLetras(reserva.nomeEmpresa)}
              </div>
              <div className="col">
                <span className="titulo-mobile">Nome:&nbsp;</span> {capitalizarTodasPrimeirasLetras(reserva.passageiroDto.nome)}
              </div>
              <div className="col">
                <span className="titulo-mobile">Cpf:&nbsp;</span> {reserva.passageiroDto.cpfPassageiro}
              </div>
              <div className="col">
                <span className="titulo-mobile">Data de embarque:&nbsp;</span> {reserva.dataHoraPartida?reserva.dataHoraPartida : '-'}
              </div>
              <div className="col">
                    <span
                        className="titulo-mobile">Origem/Destino:&nbsp;</span> {reserva.descCidadeOrigem} / {reserva.descCidadeDestino}
              </div>
              <div className="col">
                    <span
                      className="titulo-mobile">Delimitação:&nbsp;
                    </span> {reserva.delimitacao}
              </div>
              <div className="col">
                <span className="titulo-mobile">Embarcou:&nbsp;</span> {reserva.dataHoraEmbarque?reserva.dataHoraEmbarque : 'Não embarcou'}
              </div>
                <div className="col">
                    <span className="titulo-mobile">Situação:&nbsp;</span> {capitalizarTodasPrimeirasLetras(reserva.situacaoReserva.replace('_', ' '))}
                </div>
              <div className="col">
                <span className="titulo-mobile">Pedido:&nbsp;</span> {reserva.pedidoId}
              </div>
              <div className="col">
                <span className="titulo-mobile">Poltrona:&nbsp;</span> {reserva.numeroPoltrona}
              </div>
              {reserva.situacaoReserva === 'CANCELADO' ?
              <div className="col">
                <AcoesRemarcacaoCancelamento reserva={reserva}/>
              </div>
                : <div className="col">N/A</div>}
            </div>
            <div className="row mt-2" style={{ fontWeight: 'bold' }}>
                <div className="col">
                    <span>Pedido:&nbsp;</span> {reserva.pedidoId}
                </div>
                <div className="col">
                    <span>Itinerário:&nbsp;</span> {reserva.itinerarioId}
                </div>
                <div className="col">
                    <span>Rota:&nbsp;</span> {reserva.idRota}
                </div>
            </div>
          </div>
      )
    }
    return(
        <a target="_BLANK" onClick={() => this.props.alterarMarcacaoReserva(reserva)}>
          <div className={`${reserva.selecionada ? 'resumo-laranja' : 'resumo'}`}>
            <div className="row">
              <div className="col">
                <span className="titulo-mobile">Empresa:&nbsp;</span> {capitalizarTodasPrimeirasLetras(reserva.nomeEmpresa)}
              </div>
              <div className="col">
                <span className="titulo-mobile">Nome:&nbsp;</span> {capitalizarTodasPrimeirasLetras(reserva.passageiroDto.nome)}
              </div>
              <div className="col">
                <span className="titulo-mobile">Cpf:&nbsp;</span> {reserva.passageiroDto.cpfPassageiro}
              </div>
              <div className="col">
                <span className="titulo-mobile">Data de embarque:&nbsp;</span> {reserva.dataHoraPartida?reserva.dataHoraPartida : '-'}
              </div>
              <div className="col">
                    <span
                        className="titulo-mobile">Origem/Destino:&nbsp;</span> {reserva.descCidadeOrigem} / {reserva.descCidadeDestino}
              </div>
              <div className="col">
                    <span
                      className="titulo-mobile">Delimitação:&nbsp;
                    </span> {reserva.delimitacao}
              </div>
              <div className="col">
                <span className="titulo-mobile">Embarque:&nbsp;</span> {reserva.dataHoraEmbarque?reserva.dataHoraEmbarque : 'Não embarcou'}
              </div>
                <div className="col">
                    <span className="titulo-mobile">Situação:&nbsp;</span> {capitalizarTodasPrimeirasLetras(reserva.situacaoReserva)}
                </div>

              <div className="col">
                <span className="titulo-mobile">Poltrona:&nbsp;</span> {reserva.numeroPoltrona}
              </div>
              <div className="col">N/A</div>
            </div>
            <div className="row mt-2" style={{ fontWeight: 'bold' }}>
                <div className="col">
                    <span>Pedido:&nbsp;</span> {reserva.pedidoId}
                </div>
                <div className="col">
                    <span>Itinerário:&nbsp;</span> {reserva.itinerarioId}
                </div>
                <div className="col">
                    <span>Rota:&nbsp;</span> {reserva.idRota}
                </div>
            </div>
          </div>
        </a>
    )
  }
  render () {
    if (!this.props.reserva) {
      return ''
    }
    const { reserva } = this.props
    return (
        <div className="geral">
          {this.exibirReservas(reserva)}
        </div>
    )
  }
}
